import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation
} from '@angular/core';
import { MatSelectChange } from '@angular/material/select';

import { LotVM } from '../../site-map/models/lot-vm';
import { ThemeService } from '../../utility/services/theme.service';

import { ILot } from '@ml/common';
import { StatusVM } from '../../site-map/models/status-vm';
import { SettingsService } from '../../utility/services/settings.service';

@Component({
    selector: 'lot-selector',
    templateUrl: './lot-selector.component.html',
    styleUrls: ['./lot-selector.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class LotSelectorComponent implements OnInit {
  @Input() currentLot: ILot;
  @Input() lots: Array<ILot>;
  @Input() disableViewAllOption = false;
  @Input() isInventoryHome = false;
  @Input() lotLabel: string;
  @Input() allLotStatuses: StatusVM[] = [];
  @Output() selectLot = new EventEmitter<ILot>();
  @Output() selectAll = new EventEmitter();
  readonly viewAllValue = 'all';
  selectOptionsLots: LotVM[] = [];

  constructor(private theme: ThemeService, private settingsService: SettingsService) {}

  ngOnInit() {
    this.selectOptionsLots = this.lots.map(l => new LotVM(l, this.allLotStatuses));

    const statusesToHideLots: string[] =
      this.settingsService.get('StatusesToHideLotsFromDropdown') ?? [];
    if (statusesToHideLots.length) {
      this.selectOptionsLots = this.selectOptionsLots.filter(
        l => !l.MappedStatus || !statusesToHideLots.includes(l.MappedStatus.Name)
      );
    }

    if (!this.lotLabel) this.lotLabel = this.theme.lotLabel;
  }

  handleLotSelection(selectedValue: number | string, evt?: MatSelectChange) {
    evt?.source.writeValue(null);
    if (selectedValue === this.viewAllValue) {
      this.selectAll.emit();
    } else {
      const lot = this.lots.find(x => x.LotId === selectedValue);
      this.selectLot.emit(lot);
    }
  }
}
